/* eslint-disable */
import React, { ReactNode } from 'react';
import { useStore, useConfigService } from '@thd-nucleus/experience-context';
import { Metadata } from '@thd-olt-component-react/metadata';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { useThdCustomer } from '@thd-olt-functional/customer-information';

type ContainerProps = {
  children: ReactNode
}

type SearchSkipParams = {
  skip: boolean;
  queryName: string;
  attributes: any;
}

type SearchOptsParams = {
  options: any;
  queryName: string;
}

export const SearchPageContainer = ({ children }: ContainerProps) => {
  const isBuyitagainEnabled = useConfigService('fs-prop:isBuyitagainEnabled');
  const isDiscoveryZonesSearchEnabled = useConfigService('fs-prop:isDiscoveryZonesSearchEnabled');
  
  const store = useStore();
  const { isCustomerIdentified = false } = useThdCustomer() || {};
  const { membershipInformation } = store;
  
  const defaultVariables = {
    skipInstallServices: false,
    skipSpecificationGroup: false,
    isBrandPricingPolicyCompliant: isCustomerIdentified,
    loyaltyMembershipInput: membershipInformation?.data?.loyaltyMembership,
    skipBuyitagain: !isBuyitagainEnabled,
    skipDiscoveryZones: !isDiscoveryZonesSearchEnabled,
  };

  const searchSkipFn = ({ skip, queryName, attributes }: SearchSkipParams): boolean => {
    if (queryName === 'searchStreamProduct') {
      if (!attributes?.searchModel?.products?._children?.fulfillment) return true;
    }
    return skip;
  };

  const searchOptsFn = ({ options, queryName }: SearchOptsParams) => {
    if (queryName === 'searchStreamProduct') {
      options.variables = undefined;
    }

    if (queryName === 'searchModel') {
      options.context = {
        ...(options.context || {}),
        timeout: 3000
      };
    }

    return options;
  };

  return (
    <Metadata>
      <QueryProvider 
        cacheKey="page" 
        defaultVariables={defaultVariables} 
        fusion 
        skip={searchSkipFn}
        queryOptions={searchOptsFn}
        forceClientQueriesOnServer={['searchModel', 'product']}
      >
        {children}
      </QueryProvider>
    </Metadata>
  );
};

SearchPageContainer.displayName = 'SearchPageContainer';